var React = require('react');

function FacebookLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook-13"),React.createElement("circle",{"cx":"499.82","cy":"499.82","r":"499.82","fill":"#1977f3","key":1}),React.createElement("path",{"d":"M694.74,644.67l22.14-144.51H578.27V406.39c0-39.5,19.33-78.09,81.46-78.09h63v-123s-57.21-9.77-111.9-9.77c-114.15,0-188.79,69.16-188.79,194.48V500.16H295.15V644.67H422.09V993.93a501.28,501.28,0,0,0,78.09,6.05,510.07,510.07,0,0,0,78.09-6.05V644.67Z","transform":"translate(-0.36 -0.33)","fill":"#fff","key":2})]);
}

FacebookLogo.defaultProps = {"viewBox":"0 0 999.64 999.64"};

module.exports = FacebookLogo;

FacebookLogo.default = FacebookLogo;
